import { VERIFY_AUCTION_ACCESS } from '../../constants/resources';
import { getRegexpValidator } from '../../../../shared/js/util/validationUtils';

const { flex } = window;

const aa1mValidation = flex
    .getStore()
    .appContext.personIdentifiers.find((identifier) => identifier.value === 'AA1M').validation;

export const getVerifyAuctionAccessFormValidation = () => ({
    auctionAccessIdValidation: getRegexpValidation(
        'auctionAccessId',
        aa1mValidation,
        `${VERIFY_AUCTION_ACCESS.AA1M_FIELD} should be a 9-digit number beginning with a one (1)`
    ),
    governmentIssuedIdValidation: getRegexpValidation(
        'governmentIssuedId',
        '^[0-9]{4}$',
        `${VERIFY_AUCTION_ACCESS.GOV_ID_FIELD} should be a 4-digit number`
    )
});

const getRegexpValidation = (field, pattern, errorMessage, fieldName = null) => {
    const { regexp } = getRegexpValidator(field, fieldName, pattern);

    return {
        validators: { regexp },
        errorMessages: { regexp: errorMessage }
    };
};
